<div class="triangle-up"></div>
<form *ngIf="formReady" class="popup-container" [formGroup]="scheduleForm" (ngSubmit)="saveSchedule()" #schedulePopupContainer>
  <h2>
    <i class="material-icons notranslate">alarm</i>
     Schedule this Rule to run
    @if (aiContentDisclaimerVariant) {
      <app-ai-content-disclaimer [variant]="aiContentDisclaimerVariant" [inline]="true"></app-ai-content-disclaimer>
    }
    <i class="bhi-delete-o" [matTooltip]="'Remove this schedule'" (click)="deleteSchedule()" matTooltipShowDelay="500"></i>
  </h2>
  <div class="start-date-time">
    <i class="material-icons notranslate info" [matTooltip]="'The rule will run when you save'" matTooltipShowDelay="500">help</i>
    <label for="immediatelyCheckbox" [matTooltip]="'The rule will run when you save'" matTooltipShowDelay="500">Starting now</label>
    <input id="immediatelyCheckbox" type="checkbox" formControlName="immediatelyCheckbox" class="kyloe-checkbox" (change)="onImmediatelySelected()">
    <label for="startDate" [ngClass]="immediateExecution ? 'disabled' : ''" [title]="immediateExecution ? 'The scheduling will start when you save' : ''">Start</label>
    <div class="datepicker-container">
      <input matInput
             id="startDate"
             [matDatepicker]="picker_startDate"
             placeholder="dd/mm/yyyy"
             (click)="picker_startDate.open()"
             formControlName="startDate"
             [min]="currentDate"
             [title]="immediateExecution ? 'The scheduling will start when you save' : ''">

      <mat-datepicker-toggle matSuffix [for]="picker_startDate"></mat-datepicker-toggle>
      <mat-datepicker #picker_startDate></mat-datepicker>
    </div>
    <div class="timepicker-container">
        <input matInput
               [matTimepicker]="timepicker"
               formControlName="startTime"
               [title]="immediateExecution ? 'The scheduling will start when you save' : ''">

        <mat-timepicker-toggle [for]="timepicker" matSuffix></mat-timepicker-toggle>
        <mat-timepicker #timepicker interval="1m"></mat-timepicker>
    </div>
    <label>UTC</label>
    <i class="material-icons notranslate info" [matTooltip]="'Times shown are in UTC'" matTooltipShowDelay="500">help</i>
  </div>
  <div class="recur-every">
    <span>Repeat every</span>
    <mat-select formControlName="period" (opened)="disableCloseListener()" (closed)="enableCloseListener()">
      <mat-option *ngFor="let period of currentPeriods" [value]="period.value">
        {{period.value}}
      </mat-option>
    </mat-select>
    <mat-select formControlName="scheduleUnit" name="scheduleUnit" (opened)="disableCloseListener()" (closed)="enableCloseListener()">
      <mat-option *ngFor="let scheduleUnit of scheduleUnits" [value]="scheduleUnit.value">
        {{scheduleUnit.unit}}
      </mat-option>
    </mat-select>
  </div>
  <div class="run-until">
    <label for="foreverIndicator">Forever</label>
    <input id="foreverIndicator" type="checkbox" formControlName="foreverIndicator" class="kyloe-checkbox" (change)="onForeverSelected()">
    <label for="stopDate" [ngClass]="scheduleForm.controls['stopDate'].disabled ? 'disabled' : ''" [title]="scheduleForm.controls['stopDate'].disabled ? 'The rule is currently set to run forever' : ''">Until</label>
    <div class="datepicker-container">
      <input matInput
             id="stopDate"
             [matDatepicker]="picker_stopDate"
             placeholder="dd/mm/yyyy"
             (click)="picker_stopDate.open()"
             formControlName="stopDate"
             [min]="minStopDate"
             [title]="stopDateTitle()">

      <mat-datepicker-toggle matSuffix [for]="picker_stopDate"></mat-datepicker-toggle>
      <mat-datepicker #picker_stopDate></mat-datepicker>
    </div>
<!--    <input id="stopDate" type="date" formControlName="stopDate" min="{{currentDate | date:'yyyy-MM-dd'}}" [title]="stopDateTitle()">-->
  </div>
  <button [disabled]="scheduleForm.invalid || scheduleForm.untouched || isExpired" type="submit">
    Save
  </button>
<!--  {{scheduleRule | json}}-->
<!--  {{dataRule | json}}-->
<!--  {{startTime}}-->
<!--  {{startDate}}-->
</form>
